export default __webpack_public_path__ + "static/media/negetive-test-icon.a3dc5833.svg";